import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const tablesApis = createApi({
    reducerPath: 'tablesApis',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}/pos`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getTables: builder.query({
            query: () => ({
                url: `/vendor-table/get-tables`, // update URL as per your API endpoint
                method: 'GET',
            }),
            // Uncomment and update as needed:
            // transformResponse: (resp) => transformResponseHandler(resp),
            providesTags: ['vendorTables'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        getVendorTables: builder.query({
            query: () => ({
                url: `/vendor-table`, // update URL as per your API endpoint
                method: 'GET',
                params: {page:"all"}
            }),
            // Uncomment and update as needed:
            // transformResponse: (resp) => transformResponseHandler(resp),
            providesTags: ['vendorTables'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addVendorTables: builder.mutation({
            query: (body) => ({
                url:'/vendor-table',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateVendorTables: builder.mutation({
            query: ({id, ...body}) => ({
                url:`/vendor-table/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        // deleteVendorTables: builder.mutation({
        //     query: (id) => ({
        //         url: `/vendor-tables/${id}`,
        //         method: 'DELETE',
        //     }),
        //     invalidatesTags: ['vendorTables'],
        //     transformResponse: (resp) => transformResponseHandler(resp),
        //     transformErrorResponse: (error) => transformResponseHandler(error)
        // }),

        mergeVendorTables: builder.mutation({
            query: (body) => ({
                url:`/vendor-table/merge`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        splitVendorTables: builder.mutation({
            query: (body) => ({
                url:`/vendor-table/split`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        blockVendorTables: builder.mutation({
            query: (body) => ({
                url:`/vendor-table/block`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        unblockVendorTables: builder.mutation({
            query: (body) => ({
                url:`/vendor-table/unblock`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),

        addTempReservation: builder.mutation({
            query: (body) => ({
                url:`/vendor-table/temp-reservation`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        releaseTempReservation: builder.mutation({
            query: ({id}) => ({
                url:`/vendor-table/release-reservation/${id}`,
                method: 'PUT',
            }),
            invalidatesTags: ['vendorTables'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        getAvailableTables: builder.query({
            query: () => ({
                url: `/vendor-table/available`,
                method: 'GET',
            }),
            providesTags: ['vendorTables'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        changeVendorTable: builder.mutation({
            query: (body) => ({
                url: `/vendor-table/change-table`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteVendorTables: builder.mutation({
            query: (id) => ({
                url: `/vendor-table/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['vendorTables'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        generateTableQRCode: builder.mutation({
            query: (body) => ({
                url: `/vendor-table/generate-qr`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['vendorTables'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    }),
});

export const {
    useGetTablesQuery,
    useGetVendorTablesQuery,
    useAddVendorTablesMutation,
    useUpdateVendorTablesMutation,
    useDeleteVendorTablesMutation,
    useMergeVendorTablesMutation,
    useSplitVendorTablesMutation,
    useBlockVendorTablesMutation,
    useUnblockVendorTablesMutation,
    useAddTempReservationMutation,
    useReleaseTempReservationMutation,
    useGetAvailableTablesQuery,
    useChangeVendorTableMutation,
    useGenerateTableQRCodeMutation,
} = tablesApis;
